<template>
  <div class="tag-dossier" :class="{ 'has-comment': displayComment }">
    <div>
      <b-tag :class="status">
        <!-- eslint-disable vue/no-v-html -->
        <span v-html="statusLabel()"></span>
        <!-- eslint-enable vue/no-v-html -->
      </b-tag>
    </div>

    <b-tooltip
      v-if="displayComment"
      :label="comment"
      type="is-black"
      position="is-left"
      :multilined="true"
    >
      <div class="tag-dossier-commentaire" :class="status">
        <b-icon icon="comment-alt" />
      </div>
    </b-tooltip>
  </div>
</template>

<script lang="ts">
import { ProjectService } from "@/services/rest/project/ProjectService"
import { defineComponent } from "vue"
import { BIcon, BTooltip, BTag } from "buefy"
import { ProjetAnnuelDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"

export default defineComponent({
  name: "StatutDossierTag",
  components: {
    BTag,
    BIcon,
    BTooltip,
  },

  props: {
    dossier: {
      type: ProjetAnnuelDTO,
      required: true,
    },
    loggedUser: {
      type: UtilisateurDTO,
      required: true,
    },
    canSeeInstructionComment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: "BROUILLON",
      projectService: ProjectService.INSTANCE,
      displayComment: false,
      comment: "",
    }
  },
  watch: {
    dossier(_newVal: string, _oldValue: string): void {
      this.init()
    },
  },
  created(): void {
    this.init()
  },
  methods: {
    init(): void {
      if (this.dossier.statut == "BROUILLON") {
        this.status = this.dossier.statut + "_" + this.dossier.typeDossier
      } else {
        this.status = this.dossier.statut
      }

      this.configureComments()
    },

    configureComments(): void {
      this.comment = ""
      this.displayComment = false

      if (
        this.canSeeInstructionComment &&
        (this.dossier.statut === "EN_ATTENTE" || this.dossier.statut === "REFUSE") &&
        this.dossier.evaluationFinale.commentaireStatut
      ) {
        this.displayComment = true
        this.comment = this.dossier.evaluationFinale.commentaireStatut
        return
      }

      if (
        this.canSeeInstructionComment &&
        (this.dossier.statut === "ACCEPTE" ||
          this.dossier.statut === "ACCEPTE_SOUS_RESERVE_REFERENT" ||
          this.dossier.statut === "INSTRUCTION_EN_COURS") &&
        this.dossier.evaluationFinale.commentaireInstructeur
      ) {
        this.displayComment = true
        this.comment = this.dossier.evaluationFinale.commentaireInstructeur
        return
      }
    },
    statusLabel(): string {
      return this.projectService.getProjectStatusLabel(this.dossier, this.loggedUser)
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.tag-dossier {
  display: flex;
  align-content: space-between;
  width: 100%;
  align-items: flex-end;

  .tag {
    border: 1px solid;
    background-color: white;
    display: block;

    &.BROUILLON {
      border-color: $statut-brouillon;
      color: $statut-brouillon;
    }

    &.EN_ATTENTE {
      border-color: $statut-saisi;
      color: $statut-saisi;
    }

    &.ACCEPTE_SOUS_RESERVE_REFERENT {
      border-color: $statut-accepte-sous-reserve;
      color: $statut-accepte-sous-reserve;
      height: 3em;
    }

    &.ACCEPTE {
      border-color: $statut-accepte;
      color: $statut-accepte;
    }

    &.REFUSE {
      border-color: $statut-refuse;
      color: $statut-refuse;
    }

    &.LABELLISATION_EN_DEVENIR {
      border-color: $statut-en-devenir;
      color: $statut-en-devenir;
    }

    &.AVIS_PASSABLE {
      border-color: $statut-avis-passable;
      color: $statut-avis-passable;
    }

    &.INSTRUCTION_EN_COURS {
      border-color: $statut-instruction-en-cours;
      color: $statut-instruction-en-cours;
    }
  }

  &.has-comment .tag {
    border-radius: 4px 0 0 4px;
  }

  .tag-dossier-commentaire {
    border: 1px solid transparent;
    border-left-width: 0;
    border-radius: 0 4px 4px 0;
    height: 1.5em;
    padding: 0 10px;
    display: flex;
    align-items: center;

    .icon {
      width: 12px;
      height: 12px;
      vertical-align: baseline;
    }

    &.EN_ATTENTE {
      border-color: $statut-en-attente;

      .icon {
        color: $statut-en-attente;
      }
    }

    &.REFUSE {
      border-color: $statut-refuse;

      .icon {
        color: $statut-refuse;
      }
    }

    &.ACCEPTE {
      border-color: $statut-accepte;

      .icon {
        color: $statut-accepte;
      }
    }

    &.ACCEPTE_SOUS_RESERVE_REFERENT {
      border-color: $statut-accepte-sous-reserve;

      .icon {
        color: $statut-accepte-sous-reserve;
      }
    }

    &.INSTRUCTION_EN_COURS {
      border-color: $statut-instruction-en-cours;

      .icon {
        color: $statut-instruction-en-cours;
      }
    }

    &:hover {
      &.EN_ATTENTE {
        background-color: $statut-en-attente;
      }

      &.REFUSE {
        background-color: $statut-refuse;
      }

      &.ACCEPTE {
        background-color: $statut-accepte;
      }

      &.ACCEPTE_SOUS_RESERVE_REFERENT {
        background-color: $statut-accepte-sous-reserve;
      }

      &.INSTRUCTION_EN_COURS {
        background-color: $statut-instruction-en-cours;
      }

      .icon {
        color: #fff;
      }
    }
  }

  .liste-comment {
    margin: 15px;
  }
}
</style>
